import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-explore-unifiedapi',
  templateUrl: './explore-unifiedapi.component.html',
  styleUrl: './explore-unifiedapi.component.scss'
})
export class ExploreUnifiedapiComponent {
  public imageUrl = environment?.imageUrl;
  public clientAbbr = environment?.clientAbbr;

}
